import { Link } from "react-router-dom";
import { getListingUrl } from "../../../../../utils/url.utils";

export default function StyleBlocks({ styles = [] }) {
    return (
        <section className="know-style-container">
            <h2 className="section-title">Know Your Style</h2>
            <p className="section-subtitle">
                A complete guide designed to make carpet selection simple and stress-free covering styles, care tips, and inspiration to help you find the perfect fit for every room in your home.
            </p>

            {styles.map((style, index) => (
                <div
                    key={style.id}
                    className={`style-block ${index % 2 ? "reverse-layout" : ""}`}
                >
                    <img src={style.main_media} alt={style.name} title={style.name} />

                    <div className="style-content">
                        <h3>{style.name}</h3>
                        <p>{style.description}</p>
                        <div className="recommend-title">Obsessions Recommends:</div>
                        <div className="recommend-grid">
                            {style.media_gallery.map((rec) => (
                                <div key={rec.id}>
                                    <img src={rec.media} alt={rec.name} />
                                    <p style={{ fontSize: "13px", textAlign: "center" }}>{rec.name}</p>
                                </div>
                            ))}
                        </div>

                        <Link to={getListingUrl(style?.action_url)}>
                            <button className="explore-btn">{style.button_styles}</button>
                        </Link>

                    </div>
                </div>
            ))
            }
        </section >
    );
}
